const payment = {
  getlist: 'payment/getlist-by-admin',
}
export default payment
